import { FC } from 'react';
import { ProgressEstimatedProps } from './ProgressEstimated.types';
import {
  ContainerRateEstimated,
  StyledEstimated,
  StyledRateProgress,
} from './ProgressEstimated.styles';
import { AllieText } from '../../../../../components';
import { getColorBasedOnThreshold } from '../../../../../common/utils';

export const ProgressEstimated: FC<ProgressEstimatedProps> = ({
  progress,
  estimated,
  redThreshold,
  greenThreshold,
}) => {
  const isNotNullOrUndefined = (value: any) => value !== undefined && value !== null;

  return (
    <ContainerRateEstimated
      className="label center"
      // eslint-disable-next-line
      backgroundColor={`var(--allie-color-${redThreshold || greenThreshold ? getColorBasedOnThreshold(progress, redThreshold, greenThreshold, true) : ''})`}
    >
      <div>
        {
          <StyledRateProgress
            type="body1"
            weight={700}
            className="label center"
            style={{
              // eslint-disable-next-line
              color: `var(--allie-color-${redThreshold || greenThreshold ? getColorBasedOnThreshold(progress, redThreshold, greenThreshold) : 'neutral-main'}`,
            }}
          >
            {isNotNullOrUndefined(progress) ? `${progress}%` : ''}
          </StyledRateProgress>
        }
        <StyledEstimated
          type={isNotNullOrUndefined(progress) ? 'body3' : 'body1'}
          weight={isNotNullOrUndefined(progress) ? 500 : 700}
          className="label center"
        >
          {estimated}
        </StyledEstimated>
      </div>
    </ContainerRateEstimated>
  );
};
